import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=d245dd4e&scoped=true&"
import script from "./Galeria.vue?vue&type=script&lang=js&"
export * from "./Galeria.vue?vue&type=script&lang=js&"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=d245dd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d245dd4e",
  null
  
)

export default component.exports